module.exports = __webpack_public_path__ + "img/ic-twitter.b208d73e.svg";